import { Injectable } from '@angular/core';

const STORAGE_KEY = 'jf-reporting-token';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
    public get token(): string | null {
        return sessionStorage.getItem(STORAGE_KEY);
    }

    public setToken(token: string): void {
        sessionStorage.setItem(STORAGE_KEY, token);
    }

    // Expiry (epoch ms) from the JWT `exp` claim, or null if it can't be read.
    public get expiresAtMs(): number | null {
        const token = this.token;
        if (!token) return null;
        try {
            const payload = JSON.parse(atob(token.split('.')[1] ?? '')) as { exp?: number };
            return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
        } catch {
            return null;
        }
    }

    // Must run before Angular bootstrap so the first HTTP/DevExpress request
    // carries the token; capture and strip ?token= before the URL can be logged.
    public static captureFromUrl(): string | null {
        const url = new URL(window.location.href);
        const token = url.searchParams.get('token');
        if (token) {
            sessionStorage.setItem(STORAGE_KEY, token);
            url.searchParams.delete('token');
            window.history.replaceState({}, document.title, url.toString());
        }
        return sessionStorage.getItem(STORAGE_KEY);
    }

    public withToken(url: string): string {
        const token = this.token;
        const theme = sessionStorage.getItem('jf-theme');
        if (!token && !theme) return url;
        const u = new URL(url, window.location.origin);
        if (token) u.searchParams.set('token', token);
        if (theme) u.searchParams.set('theme', theme);
        return u.toString();
    }
}
